export default "__VITE_ASSET__CB2ijzMW__"